import React, { ReactNode } from 'react';
import { Formik } from 'formik';
import * as yup from 'yup';
import { useMutation } from '@apollo/client';
import EditExpiryDateForm from './EditExpiryDateForm';
import { useNotifications } from '../notifications';
import { EditExpiryDateErrorMessage } from '../consts/forms-constants';
import { mutations } from '../api';

interface EditExpiryDateFormProps {
  bodyContainer: any;
  actionsContainer: any;
  renderSecondaryAction: () => ReactNode;
  onModalHide: () => void;
  date: string;
  organizationRequestId: string;
  onSuccess?: () => void; // Optional callback for parent to refresh
}

const schema = yup.object().shape({
  date: yup.date().required(),
});

const EditExpiryDateFormik = ({
  organizationRequestId,
  date,
  bodyContainer,
  actionsContainer,
  renderSecondaryAction,
  onModalHide,
  onSuccess,
}: EditExpiryDateFormProps) => {
  const [, { error: notifyError }] = useNotifications();
  const [updateOrganizationRequestExpiry] = useMutation(mutations.updateOrganizationRequestExpiry);

  // Convert date to YYYY-MM-DD format for HTML date input
  const formatDateForInput = (dateString: string) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toISOString().split('T')[0]; // Get YYYY-MM-DD part
  };

  const onSubmit = async (values: any) => {
    try {
      await updateOrganizationRequestExpiry({
        variables: { organizationRequestId, expiresAt: values.date },
      });

      // Call parent callback to refresh data
      if (onSuccess) {
        await onSuccess();
      }

      onModalHide();
    } catch (error) {
      notifyError({ message: EditExpiryDateErrorMessage.EDIT_EXPIRY_DATE });
    }
  };

  return (
    <Formik
      validationSchema={schema}
      onSubmit={onSubmit}
      enableReinitialize
      initialValues={{
        date: formatDateForInput(date),
      }}
    >
      {(formikProps) => (
        <EditExpiryDateForm
          {...formikProps}
          bodyContainer={bodyContainer}
          actionsContainer={actionsContainer}
          renderSecondaryAction={renderSecondaryAction}
        />
      )}
    </Formik>
  );
};

export default EditExpiryDateFormik;
